import Swiper, { Navigation } from 'swiper'

const swiper = new Swiper('.up-sell', {
    modules: [Navigation],
    loop: false,
    slidesPerView: 1.5,
    spaceBetween: 16,
    navigation: {
        nextEl: '.upsell-button-next',
        prevEl: '.upsell-button-prev',
    },

    breakpoints: {
        767: {
            slidesPerView: 2.5,
        },
        991: {
            slidesPerView: 3.5,
        },
        1200: {
            slidesPerView: 4.5,
        },
        1520: {
            slidesPerView: 3.5,
        },
    },
})
